module.exports = __webpack_public_path__ + "static/media/slide0_generic.258222f5.png";